import React from 'react'
import styled from '@emotion/styled'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {ColumnFlexContainer} from '../../../Atoms/Containers'
import {Color} from '../../../Styles'
import {Typography} from '../../../Atoms/Typographies'
import {MemberAttentionExclamationIcon} from '../../../Atoms/Icons/MemberAttentionExclamationIcon'

export type AttentionSummaryProps = {
  display: boolean
  headline: string
  details?: string[]
  testId?: string
}
export const AttentionSummary: React.VFC<AttentionSummaryProps> = (
  {
    display,
    headline,
    details,
    testId,
  },
) => {
  return (<>
    {display && (
      <AttentionSummaryCard data-testid={testId ?? 'div-attention-card'}>
        <HeadlineArea>
          <StyledDiv>
            <MemberAttentionExclamationIcon/>
            <ErrorSummaryHeadlineMessage>{headline}</ErrorSummaryHeadlineMessage>
          </StyledDiv>
        </HeadlineArea>
        {details && (
          <Spacer mt={'10px'}>
            <ColumnFlexContainer textAlign={'center'} justifyContent={'center'} gap={1}>
              <AttentionSummaryDetailMessages details={details}/>
            </ColumnFlexContainer>
          </Spacer>
        )}
      </AttentionSummaryCard>
    )}
  </>)
}

const AttentionSummaryCard = styled.div`
  margin: 30px auto 20px;
  padding: 15px 16px 12px 16px;
  border: 2px solid ${Color.AttentionBorderColor};
  border-radius: 5px;
  background: ${Color.AttentionBackgroundColor};
  max-width: 600px;
`

const HeadlineArea = styled.div`
  text-align: center;
`

const StyledDiv = styled.div`
  display: inline-flex;
`

type AttentionSummaryHeadlineMessageProps = {
  children: React.ReactNode
}
const ErrorSummaryHeadlineMessage: React.VFC<AttentionSummaryHeadlineMessageProps> = (props) => {
  return (
    <Typography
      display={'inline'}
      verticalAlign={'middle'}
      fontRemSize={1.6}
      bold
      color={Color.Grey800}
    >
      {props.children}
    </Typography>
  )
}

type AttentionSummaryDetailMessageProps = {
  children: React.ReactNode
}
const AttentionSummaryDetailMessage: React.VFC<AttentionSummaryDetailMessageProps> = (props) => {
  return (
    <Typography fontRemSize={1.3} color={Color.Grey800}>
      {props.children}
    </Typography>
  )
}

type AttentionSummaryDetailMessagesProps = {
  details: string[]
}
const AttentionSummaryDetailMessages: React.VFC<AttentionSummaryDetailMessagesProps> = (
  {
    details,
  },
) => {
  return (<>
    {details.map((detail, idx) => (
      <AttentionSummaryDetailMessage key={idx}>{detail}</AttentionSummaryDetailMessage>
    ))}
  </>)
}
